module.exports = __webpack_public_path__ + "assets/img/hero_3.e1de2872.png";